import React from 'react'
import DashboardSummary from './components/DashboardSummary'
import LearnerStatusChart from './components/LearnerStatusChart'
import CompletionRateChart from './components/CompletionRateChart'
import RecentLearningPaths from './components/RecentLearningPaths'
import RecentlyEnrolledLearners from './components/RecentlyEnrolledLearners'

const Dashboard = () => {
  return (
    <section className='p-4 bg-gray-50 min-h-screen'>   
        <h3 className='text-lg font-medium mb-4'>
           Dashboard
        </h3>
        
        {/* Top Cards Section */}
        <section className='mb-6'>
           <DashboardSummary />
        </section>

        {/* Charts Section */}
        <section className='grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6'>
           <LearnerStatusChart />
           <CompletionRateChart />
        </section>

        {/* Tables Section */}
        <section className='grid grid-cols-1 lg:grid-cols-2 gap-6'>
           <RecentLearningPaths />
           <RecentlyEnrolledLearners />
        </section>
    </section>
  )
}

export default Dashboard